import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import session from 'state/session/reducer';
import billingCoupon from 'state/coupons/reducer';
import loadingSpinner from 'state/loadingSpinner/reducer';
import internalToolsUser from 'state/internalToolsUser/reducer';
import kyb from 'state/kyb/reducer';
import global from 'state/global/reducer';
import npwp from 'state/npwp/reducer';
import config from 'state/mokaConfig/reducer';
import activation from 'state/activation/reducer';
import resetPhone from 'state/resetPhone/reducer';
import bulkOutletUpdateExpiration from 'state/bulkOutletUpdateExpiration/reducer';
import access from 'state/access/reducer';
import userMapping from 'state/userMapping/reducer';
import business from 'state/business/reducer';
import discountSettings from 'state/discountSettings/reducer';
import discountRule from 'state/discountRule/reducer';
import bulkDeleteBusiness from 'state/bulkDeleteBusiness/reducer';
import changeUserEmail from 'state/changeUserEmail/reducer';
import billingPackage from 'state/billingPackage/reducer';
import additionalService from 'state/additionalService/reducer';
import hardwareCatalogue from 'state/hardwareCatalogue/reducer';
import restoreDeletedBusiness from 'state/restoreDeletedBusiness/reducer';

export default combineReducers({
  session,
  form: formReducer,
  billingCoupon,
  loadingSpinner,
  internalToolsUser,
  kyb,
  global,
  npwp,
  config,
  activation,
  resetPhone,
  bulkOutletUpdateExpiration,
  access,
  userMapping,
  business,
  discountSettings,
  discountRule,
  bulkDeleteBusiness,
  changeUserEmail,
  billingPackage,
  additionalService,
  hardwareCatalogue,
  restoreDeletedBusiness,
});
